










































































import { inject } from 'inversify-props';
import Component from "vue-class-component";
import { Model, Emit, Ref, Prop, Vue } from "vue-property-decorator";
import AddressInputGroup from "@/components/inputs/AddressInputGroup.vue";
import { auth as authStore, center as store } from "@/store/modules";
import { phoneNoRules, postalCodeRules, required } from "@/utils/validation";
import { Address } from "cluster";
import { CenterModel } from "@/models/center";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { ICenterService } from '@/interfaces/Services';
import { deepOverwrite } from '@/utils/transformers';

@Component({
  components: {
    AddressInputGroup
  }
})
class CenterEditor extends Vue {
  @inject(DependencyIdentifiers.CenterService)
  private centerService!: ICenterService;

  @Ref()
  form: any;
  enabled: boolean = false;
  get formConfig() {
    return {
      name: {
        label: this.$t('center.fields.name'),
        rules: [required]
      },
      onDutyPhone: {
        label: this.$t('center.fields.onDutyPhone'),
        rules: [required, ...phoneNoRules],
        prefix: "+36"
      }
    };
  }

  formData: Partial<CenterModel> = {
    name: "",
    onDutyPhone: "",
    $isDeveloper: false,
    address: null
  };

  isLoading = false;

  get disabled() {
    return this.enabled === false;
  }

  @Emit("cancel")
  onCancel() {}

  @Emit("created")
  onCreated(model: CenterModel) {
    return model;
  }

  @Emit("updated")
  onUpdated(model: CenterModel) {
    return model;
  }

  @Emit("save")
  onSave(model: CenterModel) {
    return model;
  }

  @Model("change")
  value!: string;

  @Prop()
  id?: string;

  async mounted() {
    this.enabled = authStore.isManager;
    this.formData.address = null;
    await this.fetchCenter();
  }

  async fetchCenter() {
    if (!this.id) {
      return;
    }
    this.isLoading = true;
    try {
      this.formData = deepOverwrite(
        this.formData,
        await this.centerService.getById(this.id)
      );
      this.componentKey++;
    } finally {
      this.isLoading = false;
    }
  }

  componentKey = 0;

  async save() {
    if (!this.form.validate()) {
      return;
    }
    this.isLoading = true;
    try {
      this.onSave(await this.upsert(this.id, this.formData as CenterModel));
    } finally {
      this.isLoading = false;
    }
  }

  private async upsert(id: any, data: CenterModel) {
    let model: CenterModel;
    if (id) {
      model = await this.centerService.update(id, data);
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.onUpdated(model);
    } else {
      model = await this.centerService.create(data);
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.onCreated(model);
    }
    return model;
  }
}
export default CenterEditor;
